module.exports = __webpack_public_path__ + "static/media/play-store-de.2efce374.svg";